import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-top-ticker',
  templateUrl: './top-ticker.component.html',
  styleUrls: ['./top-ticker.component.css']
})
export class TopTickerComponent {
  @Input() messages: string[] = [
    '🚀 Welcome to Scarce Infotech Solutions! Stay tuned for updates and announcements!',
  ];
  speed = 80;
  get duration(): string {return '25s';}
}
